import { Injectable } from '@angular/core';
import { CanLoad, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanLoad {

    constructor(private authService: AuthenticationService, private router: Router) { }

    canLoad(): Observable<boolean> {
        return new Observable<boolean>(observer => {

            this.authService.usuarioAutenticado()
                .subscribe({
                    next: (resultado: boolean) => {
                        if (resultado) {
                            observer.next(true);
                        } else {
                            this.router.navigateByUrl('/login', { replaceUrl: true });
                            observer.next(false);
                        }
                    }
                });
        });
    }
}
